import React from 'react';
import { Link } from 'react-scroll';
import Button from '../shared/Button';
import { useNavigate } from 'react-router-dom';
import hero from '../images/hero.jpg'; 

const HeroSection = () => {
  const navigate = useNavigate();
  
  return (
    <section
      id="home"
      className="relative h-screen flex items-center justify-center parallax bg-cover bg-center"
      style={{
        backgroundImage:
          `url(${hero})`,
      }}
    >
      <div className="absolute inset-0 hero-gradient"></div>
      <div className="container mx-auto px-6 relative z-10 text-center animate-fade-in">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">
          <span className="text-yellow-400">STORAGE</span> SPRINT
        </h1>
        <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-3xl mx-auto">
          Revolutionizing storage with seamless pickup, delivery, and secure storage options tailored to your needs.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Button
            onClick={() => navigate('/login')}
            primary
            className="px-8 py-4 text-lg"
          >
            Request Now <i className="fas fa-arrow-right text-white ml-2"></i>
          </Button>
          <Link
          to="services"
          smooth={true}
          className="text-white text-4xl animate-bounce cursor-pointer"
        >
          <i className="fas fa-chevron-down"></i>
        </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;